var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9097_87901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1396 0C16.242 0.00089349 16.3444 0.00276975 16.4468 0.00562869L16 15.9994L16.1396 0Z",
    fill: "#FF0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4188 0.00488281C16.5212 0.00756308 16.6235 0.0112255 16.7258 0.0158703L16 15.9994L16.4188 0.00488281Z",
    fill: "#FF0900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6979 0.015625C16.8002 0.0200913 16.9024 0.0255396 17.0046 0.031969L16 16.0004L16.6979 0.015625Z",
    fill: "#FF0D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9768 0.0302734C17.079 0.0365244 17.1812 0.0437565 17.2832 0.0519683L16 16.0004L16.9768 0.0302734Z",
    fill: "#FF1100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2554 0.0498047C17.3574 0.0578383 17.4594 0.0668518 17.5613 0.0768436L16 16.0005L17.2554 0.0498047Z",
    fill: "#FF1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5335 0.0742188C17.6355 0.0840327 17.7373 0.0948251 17.839 0.106594L16 16.0006L17.5335 0.0742188Z",
    fill: "#FF1A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8113 0.103516C17.913 0.115107 18.0146 0.127674 18.1161 0.141216L16 16.0007L17.8113 0.103516Z",
    fill: "#FF1E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0884 0.136719C18.1899 0.150084 18.2913 0.164423 18.3926 0.179734L16 15.9998L18.0884 0.136719Z",
    fill: "#FF2200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3649 0.175781C18.4662 0.190916 18.5673 0.207022 18.6683 0.224098L16 16L18.3649 0.175781Z",
    fill: "#FF2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6407 0.219727C18.7417 0.236626 18.8426 0.254495 18.9432 0.273331L16 16.0003L18.6407 0.219727Z",
    fill: "#FF2B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9158 0.267578C19.0165 0.286238 19.117 0.305864 19.2173 0.326453L16 15.9997L18.9158 0.267578Z",
    fill: "#FF2F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1899 0.321289C19.2903 0.341703 19.3904 0.36308 19.4903 0.385416L16 16.0001L19.1899 0.321289Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4631 0.378906C19.563 0.401068 19.6628 0.424189 19.7623 0.448266L16 15.9996L19.4631 0.378906Z",
    fill: "#FF3700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7351 0.441406C19.8347 0.46531 19.934 0.490168 20.0331 0.515978L16 15.9993L19.7351 0.441406Z",
    fill: "#FF3C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0061 0.509766C20.1052 0.535403 20.2041 0.561991 20.3027 0.589526L16 16.0001L20.0061 0.509766Z",
    fill: "#FF4000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2758 0.582031C20.3745 0.609395 20.4729 0.637705 20.571 0.666957L16 16.0001L20.2758 0.582031Z",
    fill: "#FF4400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5442 0.65918C20.6424 0.688261 20.7403 0.718284 20.8379 0.749244L16 16.0003L20.5442 0.65918Z",
    fill: "#FF4800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8113 0.740234C20.9089 0.771025 21.0063 0.802752 21.1033 0.835411L16 15.9997L20.8113 0.740234Z",
    fill: "#FF4D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0769 0.827148C21.174 0.859638 21.2707 0.893059 21.3672 0.927407L16 16.0003L21.0769 0.827148Z",
    fill: "#FF5100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3409 0.916992C21.4375 0.951172 21.5336 0.986277 21.6295 1.0223L16 15.9993L21.3409 0.916992Z",
    fill: "#FF5500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6033 1.0127C21.6992 1.04855 21.7948 1.08533 21.89 1.12303L16 15.9994L21.6033 1.0127Z",
    fill: "#FF5900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.864 1.11328C21.9593 1.15081 22.0542 1.18925 22.1487 1.2286L16 16L21.864 1.11328Z",
    fill: "#FF5E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.123 1.21777C22.2176 1.25696 22.3118 1.29705 22.4056 1.33804L16 15.9998L22.123 1.21777Z",
    fill: "#FF6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.38 1.32715C22.4739 1.36798 22.5674 1.40971 22.6605 1.45233L16 16.0001L22.38 1.32715Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6351 1.44043C22.7283 1.48289 22.8211 1.52625 22.9134 1.57049L16 15.9998L22.6351 1.44043Z",
    fill: "#FF6A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8882 1.55859C22.9806 1.60268 23.0726 1.64764 23.1641 1.69349L16 16L22.8882 1.55859Z",
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1392 1.68066C23.2308 1.72635 23.322 1.77292 23.4128 1.82036L16 15.9996L23.1392 1.68066Z",
    fill: "#FF7300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.388 1.80762C23.4788 1.8549 23.5692 1.90305 23.6591 1.95206L16 15.9998L23.388 1.80762Z",
    fill: "#FF7700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6346 1.93848C23.7246 1.98733 23.8141 2.03705 23.9031 2.08763L16 15.9996L23.6346 1.93848Z",
    fill: "#FF7B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8788 2.07422C23.9679 2.12464 24.0565 2.17592 24.1447 2.22804L16 15.9999L23.8788 2.07422Z",
    fill: "#FF8000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1206 2.21387C24.2089 2.26584 24.2966 2.31865 24.3838 2.3723L16 15.9999L24.1206 2.21387Z",
    fill: "#FF8400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36 2.3584C24.4473 2.4119 24.5341 2.46624 24.6203 2.5214L16 16.0006L24.36 2.3584Z",
    fill: "#FF8800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5968 2.50586C24.6831 2.56088 24.7689 2.61672 24.8542 2.67338L16 16.0001L24.5968 2.50586Z",
    fill: "#FF8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.831 2.65723C24.9164 2.71374 25.0012 2.77107 25.0855 2.82922L16 15.9994L24.831 2.65723Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0625 2.81445C25.1469 2.87245 25.2307 2.93125 25.3139 2.99086L16 16.0005L25.0625 2.81445Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2913 2.97363C25.3746 3.03309 25.4574 3.09335 25.5396 3.1544L16 15.9995L25.2913 2.97363Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5171 3.13867C25.5994 3.19958 25.6812 3.26127 25.7623 3.32375L16 16.0004L25.5171 3.13867Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7402 3.30664C25.8214 3.36897 25.9021 3.43209 25.9821 3.49597L16 16.0003L25.7402 3.30664Z",
    fill: "#FFA200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9602 3.47754C26.0404 3.54128 26.1199 3.60579 26.1988 3.67106L16 15.9992L25.9602 3.47754Z",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1772 3.6543C26.2562 3.71943 26.3346 3.78531 26.4124 3.85195L16 16.0003L26.1772 3.6543Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3911 3.83398C26.469 3.90048 26.5462 3.96773 26.6228 4.03571L16 16.0005L26.3911 3.83398Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6019 4.0166C26.6786 4.08445 26.7546 4.15303 26.83 4.22234L16 15.9999L26.6019 4.0166Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8095 4.2041C26.885 4.27328 26.9598 4.34318 27.0339 4.41379L16 16.0005L26.8095 4.2041Z",
    fill: "#FFB700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0137 4.39453C27.088 4.46501 27.1616 4.53621 27.2345 4.6081L16 16.0005L27.0137 4.39453Z",
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0137 4.39453C27.088 4.46501 27.1616 4.53621 27.2345 4.6081L16 16.0005L27.0137 4.39453Z",
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2145 4.58789C27.2876 4.65966 27.3599 4.73213 27.4316 4.80528L16 15.9999L27.2145 4.58789Z",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.412 4.78516C27.4838 4.85819 27.5548 4.93191 27.6252 5.0063L16 15.9997L27.412 4.78516Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.606 4.98633C27.6764 5.0606 27.7462 5.13555 27.8153 5.21116L16 16L27.606 4.98633Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7965 5.19043C27.8656 5.26592 27.9341 5.34208 28.0018 5.41888L16 15.9999L27.7965 5.19043Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9833 5.39746C28.0511 5.47415 28.1183 5.55149 28.1846 5.62946L16 15.9994L27.9833 5.39746Z",
    fill: "#FFD000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1665 5.6084C28.233 5.68626 28.2987 5.76476 28.3637 5.84388L16 15.9996L28.1665 5.6084Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.346 5.82324C28.4111 5.90225 28.4755 5.98188 28.5391 6.06213L16 16.0005L28.346 5.82324Z",
    fill: "#FFD900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5217 6.03906C28.5854 6.1192 28.6484 6.19994 28.7106 6.28128L16 15.9993L28.5217 6.03906Z",
    fill: "#FFDD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6937 6.25977C28.756 6.341 28.8175 6.42283 28.8783 6.50525L16 15.9999L28.6937 6.25977Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8617 6.48242C28.9226 6.56473 28.9828 6.64762 29.0421 6.73109L16 15.9996L28.8617 6.48242Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0259 6.70898C29.0853 6.79234 29.144 6.87627 29.2018 6.96076L16 16.0002L29.0259 6.70898Z",
    fill: "#FFEA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.186 6.9375C29.244 7.02189 29.3012 7.10683 29.3576 7.19231L16 16L29.186 6.9375Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3422 7.16895C29.3987 7.25433 29.4544 7.34025 29.5093 7.42671L16 15.9999L29.3422 7.16895Z",
    fill: "#FFF200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4943 7.40332C29.5493 7.48968 29.6035 7.57656 29.6568 7.66396L16 16.0001L29.4943 7.40332Z",
    fill: "#FFF700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6422 7.63965C29.6957 7.72695 29.7484 7.81477 29.8002 7.90308L16 15.9996L29.6422 7.63965Z",
    fill: "#FFFB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7861 7.87988C29.8381 7.96811 29.8892 8.05683 29.9395 8.14604L16 16.0005L29.7861 7.87988Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9257 8.12109C29.9761 8.21021 30.0257 8.29981 30.0744 8.38988L16 15.9999L29.9257 8.12109Z",
    fill: "#FBFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0611 8.36523C30.11 8.45522 30.158 8.54567 30.2051 8.63658L16 15.9997L30.0611 8.36523Z",
    fill: "#F7FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1922 8.6123C30.2395 8.70313 30.2859 8.7944 30.3314 8.88612L16 16.0003L30.1922 8.6123Z",
    fill: "#F2FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.319 8.86035C30.3646 8.95199 30.4094 9.04406 30.4534 9.13656L16 15.9995L30.319 8.86035Z",
    fill: "#EEFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4414 9.1123C30.4855 9.20472 30.5287 9.29756 30.571 9.39081L16 16.0005L30.4414 9.1123Z",
    fill: "#EAFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5594 9.36523C30.6019 9.45841 30.6434 9.55199 30.6841 9.64596L16 16.0003L30.5594 9.36523Z",
    fill: "#E6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.673 9.61914C30.7138 9.71304 30.7537 9.80733 30.7927 9.902L16 15.9991L30.673 9.61914Z",
    fill: "#E1FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7821 9.87695C30.8213 9.97155 30.8595 10.0665 30.8969 10.1619L16 15.9999L30.7821 9.87695Z",
    fill: "#DDFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8867 10.1367C30.9242 10.232 30.9608 10.3276 30.9965 10.4236L16 16.0008L30.8867 10.1367Z",
    fill: "#D9FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9868 10.3965C31.0226 10.4924 31.0576 10.5886 31.0916 10.6852L16 15.9998L30.9868 10.3965Z",
    fill: "#D5FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0823 10.6592C31.1165 10.7557 31.1497 10.8525 31.182 10.9497L16 16.0001L31.0823 10.6592Z",
    fill: "#D0FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1732 10.9229C31.2057 11.02 31.2372 11.1174 31.2678 11.2151L16 15.9997L31.1732 10.9229Z",
    fill: "#CCFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2595 11.1885C31.2903 11.2861 31.3201 11.3841 31.3491 11.4823L16 15.9998L31.2595 11.1885Z",
    fill: "#C8FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3411 11.4561C31.3702 11.5542 31.3984 11.6527 31.4256 11.7514L16 16.0003L31.3411 11.4561Z",
    fill: "#C4FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4181 11.7246C31.4455 11.8233 31.4719 11.9222 31.4973 12.0214L16 16.0004L31.4181 11.7246Z",
    fill: "#BFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4904 11.9932C31.516 12.0923 31.5407 12.1917 31.5644 12.2913L16 15.9992L31.4904 11.9932Z",
    fill: "#BBFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.558 12.2646C31.5819 12.3642 31.6048 12.464 31.6268 12.564L16 15.9998L31.558 12.2646Z",
    fill: "#B7FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6207 12.5371C31.6429 12.6371 31.6641 12.7373 31.6843 12.8376L16 16.0001L31.6207 12.5371Z",
    fill: "#B3FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6788 12.8096C31.6992 12.9099 31.7186 13.0104 31.7371 13.1111L16 15.9994L31.6788 12.8096Z",
    fill: "#AEFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7321 13.085C31.7507 13.1856 31.7684 13.2865 31.7852 13.3875L16 16.0007L31.7321 13.085Z",
    fill: "#AAFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7806 13.3594C31.7975 13.4604 31.8134 13.5615 31.8284 13.6628L16 16.0002L31.7806 13.3594Z",
    fill: "#A6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8243 13.6348C31.8394 13.736 31.8535 13.8374 31.8667 13.939L16 15.9997L31.8243 13.6348Z",
    fill: "#A2FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8631 13.9111C31.8765 14.0126 31.8889 14.1143 31.9003 14.216L16 15.9995L31.8631 13.9111Z",
    fill: "#9EFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8971 14.1885C31.9087 14.2902 31.9194 14.3921 31.929 14.494L16 15.9997L31.8971 14.1885Z",
    fill: "#99FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9264 14.4668C31.9362 14.5687 31.945 14.6707 31.9529 14.7728L16 16.0003L31.9264 14.4668Z",
    fill: "#95FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9507 14.7451C31.9587 14.8472 31.9658 14.9493 31.9718 15.0516L16 16.0005L31.9507 14.7451Z",
    fill: "#91FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9702 15.0234C31.9764 15.1256 31.9817 15.2279 31.986 15.3302L16 16.0002L31.9702 15.0234Z",
    fill: "#8CFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9847 15.3018C31.9891 15.4041 31.9926 15.5064 31.9951 15.6087L15.9999 15.9997L31.9847 15.3018Z",
    fill: "#88FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9944 15.5811C31.9971 15.6834 31.9988 15.7858 31.9995 15.8882L15.9999 15.9999L31.9944 15.5811Z",
    fill: "#84FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 15.8604C32.0002 15.9627 32.0001 16.0651 31.9991 16.1675L16 16L31.9993 15.8604Z",
    fill: "#80FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9994 16.1396C31.9985 16.242 31.9966 16.3444 31.9937 16.4468L15.9999 16L31.9994 16.1396Z",
    fill: "#7BFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9945 16.4189C31.9918 16.5212 31.9881 16.6235 31.9835 16.7258L15.9999 16L31.9945 16.4189Z",
    fill: "#77FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9848 16.6979C31.9803 16.8002 31.9749 16.9024 31.9684 17.0046L16 16L31.9848 16.6979Z",
    fill: "#73FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9701 16.9768C31.9639 17.079 31.9566 17.1812 31.9484 17.2832L16 16L31.9701 16.9768Z",
    fill: "#6FFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9507 17.2554C31.9426 17.3574 31.9336 17.4594 31.9236 17.5613L16 16L31.9507 17.2554Z",
    fill: "#6AFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9263 17.5335C31.9165 17.6355 31.9057 17.7373 31.894 17.839L16 16L31.9263 17.5335Z",
    fill: "#66FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8971 17.8113C31.8856 17.913 31.873 18.0146 31.8594 18.1161L16 16L31.8971 17.8113Z",
    fill: "#62FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8631 18.0884C31.8498 18.1899 31.8354 18.2913 31.8201 18.3926L16 16L31.8631 18.0884Z",
    fill: "#5EFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8243 18.3649C31.8091 18.4662 31.793 18.5673 31.7759 18.6683L16 16L31.8243 18.3649Z",
    fill: "#59FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7806 18.6407C31.7637 18.7417 31.7458 18.8426 31.727 18.9432L16 16L31.7806 18.6407Z",
    fill: "#55FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7321 18.9158C31.7134 19.0165 31.6938 19.117 31.6732 19.2173L16 16L31.7321 18.9158Z",
    fill: "#51FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6788 19.1899C31.6584 19.2903 31.637 19.3904 31.6146 19.4903L16 16L31.6788 19.1899Z",
    fill: "#4DFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6208 19.4631C31.5986 19.563 31.5755 19.6628 31.5514 19.7623L16 16L31.6208 19.4631Z",
    fill: "#48FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5579 19.7351C31.534 19.8347 31.5092 19.934 31.4834 20.0331L16 16L31.5579 19.7351Z",
    fill: "#44FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4904 20.0061C31.4647 20.1052 31.4381 20.2041 31.4106 20.3027L16 16L31.4904 20.0061Z",
    fill: "#40FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4181 20.2758C31.3907 20.3745 31.3624 20.4729 31.3332 20.571L16 16L31.4181 20.2758Z",
    fill: "#3CFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3411 20.5442C31.3121 20.6424 31.282 20.7403 31.2511 20.8379L16 16L31.3411 20.5442Z",
    fill: "#37FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2595 20.8113C31.2287 20.9089 31.197 21.0063 31.1643 21.1033L16 16L31.2595 20.8113Z",
    fill: "#33FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1732 21.0769C31.1407 21.174 31.1073 21.2708 31.0729 21.3672L16 16L31.1732 21.0769Z",
    fill: "#2FFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0823 21.3409C31.0481 21.4375 31.013 21.5336 30.977 21.6295L16 16L31.0823 21.3409Z",
    fill: "#2BFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9867 21.6033C30.9509 21.6992 30.9141 21.7948 30.8764 21.89L16 16L30.9867 21.6033Z",
    fill: "#26FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8867 21.864C30.8492 21.9593 30.8107 22.0542 30.7714 22.1487L16 16L30.8867 21.864Z",
    fill: "#22FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.782 22.123C30.7429 22.2176 30.7028 22.3118 30.6618 22.4056L16 16L30.782 22.123Z",
    fill: "#1EFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6729 22.38C30.6321 22.4739 30.5904 22.5674 30.5477 22.6605L16 16L30.6729 22.38Z",
    fill: "#1AFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5594 22.6351C30.5169 22.7283 30.4736 22.8211 30.4293 22.9134L16 16L30.5594 22.6351Z",
    fill: "#15FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4414 22.8882C30.3973 22.9806 30.3523 23.0726 30.3065 23.1641L16 16L30.4414 22.8882Z",
    fill: "#11FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3189 23.1392C30.2732 23.2308 30.2267 23.322 30.1792 23.4128L16 16L30.3189 23.1392Z",
    fill: "#0DFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1922 23.388C30.1449 23.4788 30.0967 23.5692 30.0477 23.6591L16 16L30.1922 23.388Z",
    fill: "#09FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.061 23.6346C30.0122 23.7246 29.9625 23.8141 29.9119 23.9031L16 16L30.061 23.6346Z",
    fill: "#04FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9257 23.8788C29.8753 23.9679 29.824 24.0565 29.7719 24.1447L16 16L29.9257 23.8788Z",
    fill: "#00FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7861 24.1206C29.7341 24.2089 29.6813 24.2966 29.6276 24.3838L16 16L29.7861 24.1206Z",
    fill: "#00FF04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6423 24.36C29.5888 24.4473 29.5344 24.5341 29.4793 24.6203L16 16L29.6423 24.36Z",
    fill: "#00FF09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4943 24.5968C29.4392 24.6831 29.3834 24.7689 29.3267 24.8542L16 16L29.4943 24.5968Z",
    fill: "#00FF0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3422 24.831C29.2857 24.9164 29.2284 25.0012 29.1702 25.0855L16 16L29.3422 24.831Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.186 25.0625C29.1281 25.1469 29.0692 25.2307 29.0096 25.3139L16 16L29.186 25.0625Z",
    fill: "#00FF15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0259 25.2912C28.9664 25.3746 28.9061 25.4574 28.8451 25.5396L16 16L29.0259 25.2912Z",
    fill: "#00FF1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8617 25.5172C28.8008 25.5995 28.7391 25.6812 28.6767 25.7623L16 16L28.8617 25.5172Z",
    fill: "#00FF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6937 25.7402C28.6314 25.8214 28.5682 25.9021 28.5044 25.9821L16 16L28.6937 25.7402Z",
    fill: "#00FF22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5217 25.9602C28.458 26.0404 28.3935 26.1199 28.3282 26.1988L16 16L28.5217 25.9602Z",
    fill: "#00FF26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.346 26.1772C28.2809 26.2562 28.215 26.3346 28.1483 26.4124L16 16L28.346 26.1772Z",
    fill: "#00FF2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1665 26.3911C28.1 26.469 28.0328 26.5462 27.9648 26.6228L16 16L28.1665 26.3911Z",
    fill: "#00FF2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9833 26.6019C27.9154 26.6786 27.8469 26.7546 27.7776 26.83L16 16L27.9833 26.6019Z",
    fill: "#00FF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7965 26.8095C27.7273 26.885 27.6574 26.9598 27.5868 27.0339L16 16L27.7965 26.8095Z",
    fill: "#00FF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.606 27.0137C27.5355 27.088 27.4643 27.1616 27.3924 27.2345L16 16L27.606 27.0137Z",
    fill: "#00FF3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.412 27.2145C27.3402 27.2876 27.2678 27.3599 27.1946 27.4316L16 16L27.412 27.2145Z",
    fill: "#00FF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2145 27.412C27.1415 27.4838 27.0678 27.5548 26.9934 27.6252L16 16L27.2145 27.412Z",
    fill: "#00FF44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0137 27.606C26.9394 27.6764 26.8645 27.7462 26.7888 27.8153L16 16L27.0137 27.606Z",
    fill: "#00FF48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8094 27.7965C26.7339 27.8656 26.6578 27.9341 26.581 28.0018L16 16L26.8094 27.7965Z",
    fill: "#00FF4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6019 27.9833C26.5252 28.0511 26.4479 28.1182 26.3699 28.1846L16 16L26.6019 27.9833Z",
    fill: "#00FF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3912 28.1665C26.3133 28.233 26.2348 28.2987 26.1557 28.3637L16 16L26.3912 28.1665Z",
    fill: "#00FF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1772 28.346C26.0982 28.4111 26.0186 28.4755 25.9383 28.5391L16 16L26.1772 28.346Z",
    fill: "#00FF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9602 28.5217C25.8801 28.5854 25.7994 28.6484 25.718 28.7106L16 16L25.9602 28.5217Z",
    fill: "#00FF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7402 28.6937C25.6589 28.756 25.5771 28.8175 25.4947 28.8783L16 16L25.7402 28.6937Z",
    fill: "#00FF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5172 28.8617C25.4349 28.9226 25.352 28.9828 25.2685 29.0421L16 16L25.5172 28.8617Z",
    fill: "#00FF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2912 29.0259C25.2079 29.0853 25.124 29.144 25.0395 29.2018L16 16L25.2912 29.0259Z",
    fill: "#00FF6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0625 29.186C24.9781 29.244 24.8932 29.3012 24.8077 29.3576L16 16L25.0625 29.186Z",
    fill: "#00FF6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.831 29.3422C24.7456 29.3987 24.6597 29.4544 24.5732 29.5093L16 16L24.831 29.3422Z",
    fill: "#00FF73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5968 29.4943C24.5104 29.5493 24.4235 29.6035 24.3361 29.6568L16 16L24.5968 29.4943Z",
    fill: "#00FF77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36 29.6422C24.2727 29.6957 24.1849 29.7484 24.0965 29.8002L16 16L24.36 29.6422Z",
    fill: "#00FF7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1206 29.7861C24.0324 29.8381 23.9437 29.8892 23.8545 29.9394L16 16L24.1206 29.7861Z",
    fill: "#00FF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8788 29.9257C23.7897 29.9761 23.7001 30.0257 23.61 30.0744L16 16L23.8788 29.9257Z",
    fill: "#00FF84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6345 30.0611C23.5445 30.11 23.4541 30.158 23.3632 30.2051L16 16L23.6345 30.0611Z",
    fill: "#00FF88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3879 30.1922C23.2971 30.2395 23.2058 30.2859 23.1141 30.3314L16 16L23.3879 30.1922Z",
    fill: "#00FF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1391 30.3189C23.0475 30.3646 22.9554 30.4094 22.8629 30.4534L16 16L23.1391 30.3189Z",
    fill: "#00FF91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8882 30.4414C22.7958 30.4855 22.7029 30.5287 22.6097 30.571L16 16L22.8882 30.4414Z",
    fill: "#00FF95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6351 30.5594C22.5419 30.6019 22.4483 30.6434 22.3544 30.6841L16 16L22.6351 30.5594Z",
    fill: "#00FF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.38 30.673C22.2861 30.7138 22.1918 30.7537 22.0971 30.7927L16 16L22.38 30.673Z",
    fill: "#00FF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.123 30.7821C22.0284 30.8213 21.9334 30.8595 21.838 30.8969L16 16L22.123 30.7821Z",
    fill: "#00FFA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.864 30.8867C21.7688 30.9242 21.6731 30.9608 21.5772 30.9965L16 16L21.864 30.8867Z",
    fill: "#00FFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6033 30.9868C21.5074 31.0226 21.4112 31.0576 21.3146 31.0916L16 16L21.6033 30.9868Z",
    fill: "#00FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3409 31.0823C21.2444 31.1165 21.1475 31.1497 21.0504 31.182L16 16L21.3409 31.0823Z",
    fill: "#00FFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0769 31.1732C20.9798 31.2057 20.8824 31.2372 20.7847 31.2678L16 16L21.0769 31.1732Z",
    fill: "#00FFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8113 31.2595C20.7136 31.2903 20.6157 31.3201 20.5174 31.3491L16 16L20.8113 31.2595Z",
    fill: "#00FFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5443 31.3411C20.4461 31.3702 20.3476 31.3984 20.2489 31.4256L16 16L20.5443 31.3411Z",
    fill: "#00FFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2758 31.4181C20.1771 31.4454 20.0782 31.4719 19.979 31.4973L16 16L20.2758 31.4181Z",
    fill: "#00FFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0061 31.4904C19.907 31.516 19.8076 31.5407 19.708 31.5644L16 16L20.0061 31.4904Z",
    fill: "#00FFC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7351 31.5579C19.6356 31.5819 19.5358 31.6048 19.4358 31.6268L16 16L19.7351 31.5579Z",
    fill: "#00FFC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4631 31.6207C19.3631 31.6429 19.2629 31.6641 19.1626 31.6843L16 16L19.4631 31.6207Z",
    fill: "#00FFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1899 31.6788C19.0895 31.6992 18.989 31.7187 18.8883 31.7372L16 16L19.1899 31.6788Z",
    fill: "#00FFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9157 31.7321C18.8151 31.7507 18.7142 31.7684 18.6132 31.7852L16 16L18.9157 31.7321Z",
    fill: "#00FFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6408 31.7806C18.5398 31.7975 18.4386 31.8134 18.3373 31.8284L16 16L18.6408 31.7806Z",
    fill: "#00FFD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.365 31.8243C18.2637 31.8394 18.1623 31.8535 18.0608 31.8667L16 16L18.365 31.8243Z",
    fill: "#00FFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0884 31.8631C17.9869 31.8765 17.8853 31.8889 17.7835 31.9003L16 16L18.0884 31.8631Z",
    fill: "#00FFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8112 31.8971C17.7095 31.9087 17.6077 31.9194 17.5057 31.929L16 16L17.8112 31.8971Z",
    fill: "#00FFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5335 31.9264C17.4316 31.9362 17.3296 31.945 17.2275 31.9529L16 16L17.5335 31.9264Z",
    fill: "#00FFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2553 31.9507C17.1533 31.9587 17.0511 31.9658 16.9489 31.9718L16 16L17.2553 31.9507Z",
    fill: "#00FFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9768 31.9702C16.8746 31.9764 16.7723 31.9817 16.67 31.986L16 16L16.9768 31.9702Z",
    fill: "#00FFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6979 31.9847C16.5956 31.9892 16.4933 31.9927 16.3909 31.9952L16 16L16.6979 31.9847Z",
    fill: "#00FFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4188 31.9945C16.3165 31.9972 16.2141 31.9989 16.1117 31.9996L16 16L16.4188 31.9945Z",
    fill: "#00FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1396 31.9994C16.0372 32.0003 15.9348 32.0002 15.8324 31.9991L16 16L16.1396 31.9994Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8604 31.9994C15.758 31.9985 15.6556 31.9966 15.5533 31.9937L16 16L15.8604 31.9994Z",
    fill: "#00FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5811 31.9946C15.4788 31.9919 15.3765 31.9882 15.2742 31.9836L16 16L15.5811 31.9946Z",
    fill: "#00F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3021 31.9848C15.1998 31.9803 15.0976 31.9749 14.9954 31.9684L16 16L15.3021 31.9848Z",
    fill: "#00F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0232 31.9701C14.921 31.9639 14.8189 31.9566 14.7168 31.9484L16 16L15.0232 31.9701Z",
    fill: "#00EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7446 31.9507C14.6426 31.9426 14.5406 31.9336 14.4387 31.9236L16 16L14.7446 31.9507Z",
    fill: "#00EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4664 31.9263C14.3645 31.9165 14.2627 31.9057 14.1609 31.894L16 16L14.4664 31.9263Z",
    fill: "#00E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1888 31.8971C14.087 31.8856 13.9854 31.873 13.8839 31.8594L16 16L14.1888 31.8971Z",
    fill: "#00E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9115 31.8631C13.81 31.8498 13.7086 31.8354 13.6074 31.8201L15.9999 16L13.9115 31.8631Z",
    fill: "#00DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.635 31.8243C13.5337 31.8091 13.4326 31.793 13.3317 31.7759L16 16L13.635 31.8243Z",
    fill: "#00D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3592 31.7806C13.2582 31.7637 13.1573 31.7458 13.0567 31.727L15.9999 16L13.3592 31.7806Z",
    fill: "#00D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0843 31.7321C12.9836 31.7134 12.8831 31.6938 12.7828 31.6732L16 16L13.0843 31.7321Z",
    fill: "#00D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.81 31.6788C12.7097 31.6584 12.6096 31.637 12.5096 31.6146L15.9999 16L12.81 31.6788Z",
    fill: "#00CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.537 31.6208C12.437 31.5986 12.3373 31.5755 12.2377 31.5514L16 16L12.537 31.6208Z",
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2648 31.5579C12.1653 31.534 12.0659 31.5092 11.9669 31.4834L16 16L12.2648 31.5579Z",
    fill: "#00C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9938 31.4904C11.8947 31.4647 11.7958 31.4381 11.6972 31.4106L15.9999 16L11.9938 31.4904Z",
    fill: "#00BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7242 31.4181C11.6255 31.3907 11.5271 31.3624 11.429 31.3332L15.9999 16L11.7242 31.4181Z",
    fill: "#00BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4557 31.3411C11.3575 31.3121 11.2596 31.282 11.162 31.2511L15.9999 16L11.4557 31.3411Z",
    fill: "#00B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1887 31.2595C11.091 31.2287 10.9937 31.197 10.8966 31.1643L15.9999 16L11.1887 31.2595Z",
    fill: "#00B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9231 31.1732C10.826 31.1407 10.7292 31.1073 10.6328 31.0729L16 16L10.9231 31.1732Z",
    fill: "#00AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.659 31.0823C10.5625 31.0481 10.4663 31.013 10.3705 30.977L15.9999 16L10.659 31.0823Z",
    fill: "#00AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3967 30.9867C10.3008 30.9509 10.2052 30.9141 10.11 30.8764L15.9999 16L10.3967 30.9867Z",
    fill: "#00A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.136 30.8867C10.0407 30.8492 9.94579 30.8107 9.85126 30.7714L16 16L10.136 30.8867Z",
    fill: "#00A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87701 30.782C9.78241 30.7429 9.68819 30.7028 9.59436 30.6618L15.9999 16L9.87701 30.782Z",
    fill: "#009DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61998 30.6729C9.52608 30.6321 9.43258 30.5904 9.33948 30.5477L16 16L9.61998 30.6729Z",
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36489 30.5594C9.27171 30.5169 9.17895 30.4736 9.08661 30.4294L16 16L9.36489 30.5594Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11178 30.4414C9.01936 30.3973 8.92737 30.3523 8.83582 30.3065L15.9999 16L9.11178 30.4414Z",
    fill: "#0091FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86079 30.3189C8.76915 30.2732 8.67796 30.2267 8.58722 30.1792L15.9999 16L8.86079 30.3189Z",
    fill: "#008CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61197 30.1922C8.52115 30.1449 8.43078 30.0967 8.34088 30.0477L15.9999 16L8.61197 30.1922Z",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36545 30.061C8.27547 30.0122 8.18595 29.9625 8.09692 29.9119L16 16L8.36545 30.061Z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12117 29.9257C8.03205 29.8753 7.94342 29.824 7.85529 29.7719L15.9999 16L8.12117 29.9257Z",
    fill: "#0080FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87937 29.7861C7.79115 29.7341 7.70342 29.6813 7.61621 29.6276L16 16L7.87937 29.7861Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64 29.6423C7.55269 29.5888 7.4659 29.5344 7.37964 29.4793L16 16L7.64 29.6423Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40316 29.4943C7.3168 29.4392 7.23098 29.3834 7.14569 29.3267L15.9999 16L7.40316 29.4943Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16894 29.3422C7.08355 29.2857 6.99871 29.2284 6.91443 29.1702L15.9999 16L7.16894 29.3422Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 29.1861C6.85312 29.1281 6.76929 29.0692 6.68604 29.0096L16 16L6.9375 29.1861Z",
    fill: "#006AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70874 29.0258C6.62538 28.9664 6.54259 28.9061 6.46039 28.8451L16 16L6.70874 29.0258Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48283 28.8617C6.40052 28.8008 6.3188 28.7391 6.23767 28.6767L16 16L6.48283 28.8617Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 28.6937C6.17854 28.6314 6.09791 28.5682 6.01788 28.5044L15.9999 16L6.25977 28.6937Z",
    fill: "#005EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03976 28.5217C5.95962 28.458 5.8801 28.3935 5.80121 28.3282L16 16L6.03976 28.5217Z",
    fill: "#0059FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82272 28.346C5.74371 28.2809 5.66533 28.215 5.58759 28.1483L15.9999 16L5.82272 28.346Z",
    fill: "#0055FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60879 28.1665C5.53093 28.1 5.45371 28.0328 5.37714 27.9648L15.9999 16L5.60879 28.1665Z",
    fill: "#0051FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39808 27.9833C5.32139 27.9154 5.24535 27.8469 5.16998 27.7776L16 16L5.39808 27.9833Z",
    fill: "#004DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19053 27.7965C5.11504 27.7273 5.04021 27.6574 4.96606 27.5868L15.9999 16L5.19053 27.7965Z",
    fill: "#0048FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98628 27.606C4.912 27.5355 4.83841 27.4643 4.7655 27.3924L15.9999 16L4.98628 27.606Z",
    fill: "#0044FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78544 27.412C4.7124 27.3402 4.64006 27.2678 4.56842 27.1946L16 16L4.78544 27.412Z",
    fill: "#0040FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58794 27.2145C4.51618 27.1415 4.44511 27.0678 4.37476 26.9934L15.9999 16L4.58794 27.2145Z",
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39399 27.0137C4.3235 26.9394 4.25374 26.8644 4.18469 26.7888L15.9999 16L4.39399 27.0137Z",
    fill: "#0037FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20351 26.8094C4.13433 26.7339 4.06588 26.6578 3.99817 26.581L15.9999 16L4.20351 26.8094Z",
    fill: "#0033FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01669 26.6019C3.94884 26.5252 3.88173 26.4479 3.81537 26.3699L16 16L4.01669 26.6019Z",
    fill: "#002FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83347 26.3912C3.76697 26.3133 3.70122 26.2348 3.63623 26.1557L16 16L3.83347 26.3912Z",
    fill: "#002BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65398 26.1773C3.58885 26.0982 3.52448 26.0186 3.46088 25.9384L16 16L3.65398 26.1773Z",
    fill: "#0026FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47821 25.9602C3.41447 25.8801 3.3515 25.7994 3.28931 25.718L15.9999 16L3.47821 25.9602Z",
    fill: "#0022FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30629 25.7402C3.24396 25.6589 3.18241 25.5771 3.12164 25.4947L15.9999 16L3.30629 25.7402Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13828 25.5172C3.07738 25.4349 3.01726 25.352 2.95795 25.2685L16 16L3.13828 25.5172Z",
    fill: "#001AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97412 25.2913C2.91466 25.2079 2.85601 25.124 2.79816 25.0395L15.9999 16L2.97412 25.2913Z",
    fill: "#0015FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81394 25.0625C2.75595 24.9781 2.69876 24.8932 2.6424 24.8077L16 16L2.81394 25.0625Z",
    fill: "#0011FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6578 24.831C2.60128 24.7456 2.54559 24.6597 2.49072 24.5732L15.9999 16L2.6578 24.831Z",
    fill: "#000DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50575 24.5968C2.45073 24.5104 2.39655 24.4236 2.3432 24.3362L16 16L2.50575 24.5968Z",
    fill: "#0009FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35774 24.36C2.30424 24.2727 2.25158 24.1849 2.19977 24.0965L16 16L2.35774 24.36Z",
    fill: "#0004FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2139 24.1206C2.16193 24.0324 2.11081 23.9437 2.06055 23.8545L16 16L2.2139 24.1206Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07428 23.8788C2.02386 23.7897 1.9743 23.7001 1.9256 23.61L15.9999 16L2.07428 23.8788Z",
    fill: "#0400FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93889 23.6345C1.89004 23.5445 1.84204 23.4541 1.79492 23.3632L15.9999 16L1.93889 23.6345Z",
    fill: "#0900FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80779 23.3879C1.76051 23.2971 1.71411 23.2058 1.66858 23.1141L16 16L1.80779 23.3879Z",
    fill: "#0D00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68098 23.1392C1.6353 23.0475 1.59049 22.9554 1.54657 22.8629L15.9999 16L1.68098 23.1392Z",
    fill: "#1100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55859 22.8882C1.51451 22.7958 1.47132 22.7029 1.42902 22.6097L15.9999 16L1.55859 22.8882Z",
    fill: "#1500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44061 22.6351C1.39815 22.5419 1.35658 22.4483 1.31592 22.3544L16 16L1.44061 22.6351Z",
    fill: "#1A00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32699 22.38C1.28616 22.2861 1.24623 22.1918 1.20721 22.0971L15.9999 16L1.32699 22.38Z",
    fill: "#1E00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21791 22.123C1.17872 22.0284 1.14045 21.9334 1.10309 21.838L16 16L1.21791 22.123Z",
    fill: "#2200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11331 21.864C1.07578 21.7688 1.03917 21.6731 1.00348 21.5772L16 16L1.11331 21.864Z",
    fill: "#2600FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01319 21.6033C0.977335 21.5074 0.942397 21.4112 0.908386 21.3146L15.9999 16L1.01319 21.6033Z",
    fill: "#2B00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.917685 21.3409C0.883505 21.2444 0.850253 21.1475 0.817932 21.0504L15.9999 16L0.917685 21.3409Z",
    fill: "#2F00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.826784 21.0769C0.794294 20.9798 0.762737 20.8824 0.732117 20.7847L15.9999 16L0.826784 21.0769Z",
    fill: "#3300FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740493 20.8113C0.709702 20.7136 0.67985 20.6157 0.65094 20.5174L16 16L0.740493 20.8113Z",
    fill: "#3700FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.658873 20.5443C0.629792 20.4461 0.601654 20.3476 0.574463 20.2489L16 16L0.658873 20.5443Z",
    fill: "#3C00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.581868 20.2758C0.554504 20.1771 0.528089 20.0782 0.502625 19.979L16 16L0.581868 20.2758Z",
    fill: "#4000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.509599 20.0061C0.483961 19.907 0.459276 19.8076 0.435547 19.708L16 16L0.509599 20.0061Z",
    fill: "#4400FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.442068 19.7351C0.418164 19.6356 0.395217 19.5358 0.37323 19.4358L16 16L0.442068 19.7351Z",
    fill: "#4800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.379215 19.4631C0.357053 19.3631 0.335852 19.2629 0.315613 19.1626L16 16L0.379215 19.4631Z",
    fill: "#4D00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.321165 19.1899C0.300752 19.0895 0.281301 18.989 0.262817 18.8883L15.9999 16L0.321165 19.1899Z",
    fill: "#5100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.26792 18.9157C0.24926 18.8151 0.231567 18.7142 0.214844 18.6132L16 16L0.26792 18.9157Z",
    fill: "#5500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.219419 18.6408C0.202519 18.5398 0.186589 18.4386 0.171631 18.3373L16 16L0.219419 18.6408Z",
    fill: "#5900FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.175725 18.365C0.16059 18.2637 0.146428 18.1623 0.13324 18.0608L16 16L0.175725 18.365Z",
    fill: "#5E00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.136839 18.0884C0.123474 17.9869 0.111084 17.8853 0.0996704 17.7835L15.9999 16L0.136839 18.0884Z",
    fill: "#6200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.102826 17.8112C0.0912343 17.7095 0.0806199 17.6077 0.0709839 17.5057L16 16L0.102826 17.8112Z",
    fill: "#6600FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0736241 17.5335C0.0638101 17.4316 0.0549747 17.3296 0.0471191 17.2275L15.9999 16L0.0736241 17.5335Z",
    fill: "#6A00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0492972 17.2553C0.0412634 17.1533 0.0342098 17.0511 0.0281372 16.9489L16 16L0.0492972 17.2553Z",
    fill: "#6F00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0297856 16.9768C0.0235346 16.8746 0.0182649 16.7723 0.0139771 16.67L16 16L0.0297856 16.9768Z",
    fill: "#7300FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015213 16.6979C0.0107467 16.5956 0.00726244 16.4933 0.00476074 16.3909L16 16L0.015213 16.6979Z",
    fill: "#7700FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0054591 16.4189C0.00277876 16.3165 0.00108105 16.2141 0.000366211 16.1117L16 16L0.0054591 16.4189Z",
    fill: "#7B00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000609234 16.1402C-0.000284308 16.0378 -0.000194953 15.9354 0.000877287 15.833L16 16.0006L0.000609234 16.1402Z",
    fill: "#8000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000549316 15.8608C0.00144285 15.7584 0.00331924 15.6561 0.00617822 15.5537L15.9999 16.0005L0.000549316 15.8608Z",
    fill: "#8400FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00543213 15.5814C0.00811247 15.479 0.0117753 15.3767 0.0164202 15.2744L15.9999 16.0002L0.00543213 15.5814Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0151978 15.3028C0.0196641 15.2005 0.0251123 15.0983 0.0315416 14.9961L15.9999 16.0007L0.0151978 15.3028Z",
    fill: "#8C00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0297852 15.0232C0.0360361 14.921 0.043268 14.8189 0.0514798 14.7168L15.9999 16L0.0297852 15.0232Z",
    fill: "#9100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0493164 14.7445C0.0573501 14.6424 0.0663635 14.5404 0.0763553 14.4385L16 15.9998L0.0493164 14.7445Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0736084 14.4666C0.0834224 14.3647 0.0942145 14.2628 0.105983 14.1611L15.9999 16.0001L0.0736084 14.4666Z",
    fill: "#9900FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.102844 14.1886C0.114436 14.0869 0.127003 13.9853 0.140545 13.8838L16 15.9999L0.102844 14.1886Z",
    fill: "#9D00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.136841 13.9116C0.150206 13.8101 0.164545 13.7087 0.179857 13.6074L16 16L0.136841 13.9116Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.17572 13.6354C0.190855 13.5341 0.206961 13.433 0.224038 13.332L15.9999 16.0003L0.17572 13.6354Z",
    fill: "#A600FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.219421 13.3591C0.236321 13.2581 0.25419 13.1573 0.273026 13.0566L16 15.9998L0.219421 13.3591Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.267883 13.0847C0.286543 12.984 0.306169 12.8835 0.326758 12.7832L16 16.0004L0.267883 13.0847Z",
    fill: "#AE00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.321167 12.8102C0.341581 12.7098 0.362958 12.6097 0.385294 12.5098L15.9999 16L0.321167 12.8102Z",
    fill: "#B300FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.379211 12.5375C0.401373 12.4376 0.424494 12.3378 0.448571 12.2383L15.9999 16.0005L0.379211 12.5375Z",
    fill: "#B700FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.442078 12.2648C0.465981 12.1652 0.490839 12.0659 0.516649 11.9668L16 15.9999L0.442078 12.2648Z",
    fill: "#BB00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.509583 11.9939C0.53522 11.8948 0.561808 11.7959 0.589344 11.6973L15.9999 16L0.509583 11.9939Z",
    fill: "#BF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.581909 11.7239C0.609273 11.6252 0.637583 11.5268 0.666835 11.4287L16 15.9997L0.581909 11.7239Z",
    fill: "#C400FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.658875 11.4558C0.687956 11.3576 0.717979 11.2597 0.74894 11.1621L16 16L0.658875 11.4558Z",
    fill: "#C800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740479 11.1885C0.771269 11.0909 0.802996 10.9935 0.835655 10.8965L16 15.9998L0.740479 11.1885Z",
    fill: "#CC00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.826782 10.9232C0.859272 10.8261 0.892693 10.7293 0.927041 10.6328L15.9999 16.0001L0.826782 10.9232Z",
    fill: "#D000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.917725 10.6596C0.951904 10.5631 0.987009 10.4669 1.02304 10.3711L16 16.0006L0.917725 10.6596Z",
    fill: "#D500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01324 10.397C1.0491 10.3011 1.08588 10.2056 1.12358 10.1104L16 16.0003L1.01324 10.397Z",
    fill: "#D900FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11328 10.1363C1.15081 10.041 1.18925 9.94609 1.2286 9.85156L16 16.0003L1.11328 10.1363Z",
    fill: "#DD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2179 9.87738C1.25708 9.78278 1.29717 9.68856 1.33816 9.59473L16 16.0003L1.2179 9.87738Z",
    fill: "#E100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32703 9.62035C1.36786 9.52645 1.40959 9.43294 1.45221 9.33984L16 16.0004L1.32703 9.62035Z",
    fill: "#E600FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44061 9.36519C1.48307 9.27202 1.52643 9.17926 1.57067 9.08691L16 16.0003L1.44061 9.36519Z",
    fill: "#EA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55859 9.11191C1.60268 9.01949 1.64764 8.92749 1.69349 8.83594L15.9999 16.0001L1.55859 9.11191Z",
    fill: "#EE00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68103 8.86146C1.72672 8.76983 1.77328 8.67863 1.82072 8.58789L16 16.0006L1.68103 8.86146Z",
    fill: "#F200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8078 8.61191C1.85508 8.52109 1.90323 8.43072 1.95225 8.34082L16 15.9999L1.8078 8.61191Z",
    fill: "#F700FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9389 8.36521C1.98776 8.27522 2.03748 8.18571 2.08806 8.09668L16 15.9997L1.9389 8.36521Z",
    fill: "#FB00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07428 8.12135C2.1247 8.03224 2.17598 7.9436 2.2281 7.85547L16 16.0001L2.07428 8.12135Z",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21393 7.87937C2.2659 7.79115 2.31871 7.70342 2.37236 7.61621L16 16L2.21393 7.87937Z",
    fill: "#FF00FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35773 7.64024C2.41123 7.55293 2.46556 7.46614 2.52073 7.37988L16 16.0002L2.35773 7.64024Z",
    fill: "#FF00F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50568 7.40298C2.56069 7.31662 2.61654 7.23079 2.6732 7.14551L15.9999 15.9998L2.50568 7.40298Z",
    fill: "#FF00F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65778 7.16955C2.71429 7.08416 2.77162 6.99932 2.82977 6.91504L15.9999 16.0005L2.65778 7.16955Z",
    fill: "#FF00EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81396 6.93799C2.87196 6.85361 2.93077 6.76978 2.99037 6.68652L16 16.0005L2.81396 6.93799Z",
    fill: "#FF00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97412 6.70831C3.03358 6.62495 3.09384 6.54216 3.15489 6.45996L15.9999 15.9995L2.97412 6.70831Z",
    fill: "#FF00E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13824 6.48246C3.19915 6.40015 3.26085 6.31843 3.32332 6.2373L15.9999 15.9996L3.13824 6.48246Z",
    fill: "#FF00E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30627 6.25947C3.36861 6.17823 3.43172 6.0976 3.4956 6.01758L15.9999 15.9996L3.30627 6.25947Z",
    fill: "#FF00DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47821 6.03933C3.54195 5.9592 3.60646 5.87968 3.67173 5.80078L15.9999 15.9996L3.47821 6.03933Z",
    fill: "#FF00D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65399 5.82205C3.71912 5.74304 3.78501 5.66466 3.85164 5.58691L16 15.9993L3.65399 5.82205Z",
    fill: "#FF00D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83344 5.6086C3.89993 5.53074 3.96718 5.45352 4.03516 5.37695L15.9999 15.9997L3.83344 5.6086Z",
    fill: "#FF00D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01672 5.39802C4.08457 5.32133 4.15315 5.24529 4.22246 5.16992L16 15.9999L4.01672 5.39802Z",
    fill: "#FF00CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20349 5.19029C4.27267 5.1148 4.34257 5.03997 4.41318 4.96582L15.9999 15.9997L4.20349 5.19029Z",
    fill: "#FF00C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39398 4.9864C4.46446 4.91213 4.53566 4.83853 4.60755 4.76562L15.9999 16L4.39398 4.9864Z",
    fill: "#FF00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58795 4.78537C4.65972 4.71234 4.73219 4.64 4.80535 4.56836L16 15.9999L4.58795 4.78537Z",
    fill: "#FF00BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78546 4.58819C4.85849 4.51642 4.93221 4.44535 5.00661 4.375L16 16.0002L4.78546 4.58819Z",
    fill: "#FF00BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98633 4.39387C5.0606 4.32338 5.13555 4.25361 5.21116 4.18457L16 15.9999L4.98633 4.39387Z",
    fill: "#FF00B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19055 4.20339C5.26604 4.13421 5.3422 4.06576 5.41901 3.99805L16 15.9998L5.19055 4.20339Z",
    fill: "#FF00B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39801 4.01675C5.4747 3.9489 5.55204 3.88179 5.63001 3.81543L15.9999 16L5.39801 4.01675Z",
    fill: "#FF00AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60876 3.83396C5.68663 3.76746 5.76512 3.70171 5.84425 3.63672L15.9999 16.0005L5.60876 3.83396Z",
    fill: "#FF00AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82269 3.65404C5.9017 3.58891 5.98133 3.52454 6.06158 3.46094L15.9999 16L5.82269 3.65404Z",
    fill: "#FF00A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03973 3.47797C6.11987 3.41422 6.20061 3.35125 6.28195 3.28906L15.9999 15.9997L6.03973 3.47797Z",
    fill: "#FF00A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 3.30672C6.341 3.24438 6.42283 3.18283 6.50525 3.12207L15.9999 16.0004L6.25977 3.30672Z",
    fill: "#FF009D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48285 3.13834C6.56516 3.07744 6.64805 3.01732 6.73151 2.95801L16 16.0001L6.48285 3.13834Z",
    fill: "#FF0099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70868 2.97382C6.79204 2.91436 6.87597 2.8557 6.96045 2.79785L15.9999 15.9996L6.70868 2.97382Z",
    fill: "#FF0095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 2.81412C7.02188 2.75613 7.10682 2.69894 7.19231 2.64258L16 16.0001L6.9375 2.81412Z",
    fill: "#FF0091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16895 2.65828C7.25433 2.60177 7.34025 2.54608 7.42671 2.49121L15.9999 16.0005L7.16895 2.65828Z",
    fill: "#FF008C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4032 2.50532C7.48956 2.45031 7.57644 2.39612 7.66384 2.34277L16 15.9996L7.4032 2.50532Z",
    fill: "#FF0088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64001 2.35817C7.72732 2.30467 7.81513 2.25201 7.90345 2.2002L16 16.0004L7.64001 2.35817Z",
    fill: "#FF0084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87939 2.2139C7.96762 2.16193 8.05634 2.11081 8.14555 2.06055L16 15.9999L7.87939 2.2139Z",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12122 2.07447C8.21033 2.02405 8.29993 1.97448 8.39 1.92578L16 16.0002L8.12122 2.07447Z",
    fill: "#FF007B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36542 1.9389C8.4554 1.89004 8.54586 1.84204 8.63676 1.79492L15.9999 16L8.36542 1.9389Z",
    fill: "#FF0077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.612 1.80718C8.70282 1.7599 8.7941 1.7135 8.88581 1.66797L15.9999 15.9994L8.612 1.80718Z",
    fill: "#FF0073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86078 1.68129C8.95241 1.6356 9.04449 1.5908 9.13698 1.54688L16 16.0002L8.86078 1.68129Z",
    fill: "#FF006F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11182 1.55828C9.20423 1.5142 9.29707 1.47101 9.39032 1.42871L16 15.9996L9.11182 1.55828Z",
    fill: "#FF006A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36487 1.44012C9.45804 1.39766 9.55162 1.35609 9.64559 1.31543L16 15.9995L9.36487 1.44012Z",
    fill: "#FF0066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62 1.32681C9.7139 1.28598 9.80819 1.24605 9.90285 1.20703L16 15.9998L9.62 1.32681Z",
    fill: "#FF0062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87701 1.21736C9.97161 1.17818 10.0666 1.1399 10.1619 1.10254L15.9999 15.9994L9.87701 1.21736Z",
    fill: "#FF005E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1359 1.11276C10.2312 1.07523 10.3268 1.03862 10.4228 1.00293L15.9999 15.9994L10.1359 1.11276Z",
    fill: "#FF0059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3967 1.01301C10.4926 0.977152 10.5888 0.942214 10.6854 0.908203L16 15.9998L10.3967 1.01301Z",
    fill: "#FF0055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6591 0.917135C10.7556 0.882955 10.8524 0.849703 10.9496 0.817383L16 15.9994L10.6591 0.917135Z",
    fill: "#FF0051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9231 0.827089C11.0202 0.794599 11.1176 0.763042 11.2153 0.732422L15.9999 16.0003L10.9231 0.827089Z",
    fill: "#FF004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1887 0.740919C11.2863 0.710129 11.3843 0.680277 11.4825 0.651367L15.9999 16.0004L11.1887 0.740919Z",
    fill: "#FF0048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4557 0.658629C11.5539 0.629548 11.6524 0.60141 11.7511 0.574219L16 15.9997L11.4557 0.658629Z",
    fill: "#FF0044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7241 0.581197C11.8228 0.553833 11.9217 0.527417 12.0209 0.501953L15.9999 15.9993L11.7241 0.581197Z",
    fill: "#FF0040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9938 0.509599C12.093 0.483961 12.1923 0.459276 12.292 0.435547L15.9999 15.9999L11.9938 0.509599Z",
    fill: "#FF003C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2648 0.441885C12.3644 0.417981 12.4642 0.395034 12.5642 0.373047L15.9999 15.9998L12.2648 0.441885Z",
    fill: "#FF0037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5369 0.379033C12.6369 0.356871 12.7371 0.335668 12.8374 0.31543L15.9999 15.9998L12.5369 0.379033Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8101 0.321044C12.9104 0.30063 13.0109 0.281179 13.1116 0.262695L15.9999 15.9998L12.8101 0.321044Z",
    fill: "#FF002F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0842 0.26792C13.1848 0.24926 13.2857 0.231567 13.3867 0.214844L15.9999 16L13.0842 0.26792Z",
    fill: "#FF002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3592 0.218686C13.4602 0.201786 13.5613 0.185856 13.6626 0.170898L15.9999 15.9992L13.3592 0.218686Z",
    fill: "#FF0026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.635 0.176274C13.7363 0.161139 13.8377 0.146977 13.9392 0.133789L15.9999 16.0005L13.635 0.176274Z",
    fill: "#FF0022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9116 0.136779C14.0131 0.123414 14.1147 0.111023 14.2165 0.0996094L16 15.9999L13.9116 0.136779Z",
    fill: "#FF001E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1887 0.103131C14.2904 0.0915396 14.3922 0.0809251 14.4942 0.0712891L15.9999 16.0003L14.1887 0.103131Z",
    fill: "#FF001A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4665 0.0733796C14.5684 0.0635657 14.6704 0.0547305 14.7725 0.046875L16 15.9997L14.4665 0.0733796Z",
    fill: "#FF0015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7446 0.04948C14.8467 0.0414463 14.9489 0.0343929 15.0511 0.0283203L15.9999 16.0002L14.7446 0.04948Z",
    fill: "#FF0011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0232 0.0304568C15.1254 0.0242058 15.2277 0.0189362 15.33 0.0146484L16 16.0006L15.0232 0.0304568Z",
    fill: "#FF000D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3021 0.0153346C15.4044 0.0108684 15.5067 0.00738442 15.6091 0.00488281L16 16.0001L15.3021 0.0153346Z",
    fill: "#FF0009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5812 0.00509303C15.6835 0.00241265 15.7859 0.000714858 15.8883 0L16 15.9996L15.5812 0.00509303Z",
    fill: "#FF0004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "url(#paint0_radial_9097_87901)",
    stroke: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9097_87901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9097_87901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeCustom);
export default __webpack_public_path__ + "static/media/theme-custom.7df6f12f.svg";
export { ForwardRef as ReactComponent };